import React from 'react';
import PropTypes from 'prop-types';
import { GhostButton } from 'lib/styles';
import styled from 'styled-components';

const Button = styled(GhostButton)`
	margin-bottom: 16px;

	&:nth-last-child(1) {
		margin-bottom: 0;
	}
`;

const Cancel = props => {
	return (
		<Button onClick={props.cancelHandler}>{props.value}</Button>
	)
}

Cancel.propTypes = {
	value: PropTypes.string,
	cancelHandler: PropTypes.func,
}

export default Cancel
